export default __webpack_public_path__ + "static/media/480_dummy2016-ernaehrungsberatung01-mobile-de.bfb43a4e.png";